import { render, staticRenderFns } from "./keben.vue?vue&type=template&id=c5083156&scoped=true"
import script from "./keben.vue?vue&type=script&lang=js"
export * from "./keben.vue?vue&type=script&lang=js"
import style0 from "./keben.vue?vue&type=style&index=0&id=c5083156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5083156",
  null
  
)

export default component.exports